<template>
  <div>
    <div class="random-rewards_unknown-error random-rewards_unknown-error-wrapper">
      <h3 class="heading3">{{ $c('Что-то пошло не так') }}</h3>
      <h1 class="heading1">{{ $c('Похоже, возникла какая-то проблема. Не переживай, мы её уже решаем!') }}</h1>
      <p class="paragraph">{{ $c('Попробуй перезагрузить страницу.') }}</p>
      <a @click="reloadPage" class="button contained">{{ $c('Перезагрузить') }}</a>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({})
class UnknownError extends Vue {
  reloadPage () {
    window.location.reload()
  }
}

export default UnknownError
</script>

<style lang="scss">
.random-rewards_unknown-error {
  &-wrapper {
    max-width: 700px;
    padding: 32px 30px;
    box-sizing: border-box;
    @include media_desktop {
      padding: 80px;
    }
    &__bound {
      padding-bottom: 50px;
    }
  }
  .heading1 {
    margin-bottom: 30px;
  }
  .heading3 {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 25px;
    color: #666666;
    margin-bottom: 12px;
  }
  .paragraph {
    font-size: 20px;
    margin-bottom: 50px;
  }
}

</style>
